import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';

/**
 * Proto log DTO for records
 */
@CaslSubject(AppSubjectEnum.PROTO_LOG)
export class ProtoLogRecordDto extends BaseDto {
	/**
	 * Audit log ID
	 */
	auditLogId!: number;

	/**
	 * User ID
	 */
	userId!: number;

	/**
	 * Composite key describing the event and action that triggered the log
	 */
	key!: string;

	/**
	 * Source subject of the log
	 */
	subject!: AppSubjectEnum;

	/**
	 * Source subject ID of the log
	 */
	subjectId!: number;

	/**
	 * Unique token for the log
	 */
	token!: string;
}
